export default __webpack_public_path__ + "79a87181aec94b5e1d21942963ebe634.png";